module.exports = __webpack_public_path__ + "img/intropage-dna-icon.56dd42f7.svg";